import { render } from "./ResetPwd.vue?vue&type=template&id=fed961c8"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"

import exportComponent from "E:\\H5\\pay_h5_uni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__